/* eslint-disable no-param-reassign */

export default function swap(arr, x, y) {
  const b = arr[x];
  arr[x] = arr[y];
  arr[y] = b;
  return arr;
}
